import Popup from '@/components/popup'
import { useTranslation } from 'react-i18next'
import { GetCatgoryLookup, GetServiceTypeLookUp } from '@/api/endpoints'
import { AddServiceCategory, GetserviceCatgoryById, updateServiceCategory } from '@/api/endpoints'
import { SERVICES_TYPES } from '@/data/Constant'
import useForm from '@/hooks/useForm'
import { DropDown, FileUpload, MLInputField } from '@/components/Exporter'
import { LoadListDefault, useGet, usePost, useUpdate } from '@/api/hooks'
import { convertToFormData } from '@/hooks/useFormData'

const modalName = 'service-category-modal'

const ReqObject = (data) => {
    return convertToFormData(data)
}

const GetCatgories = (Id) => GetCatgoryLookup(Id)


const commontFieldsProps=(name, fh) =>({
    className: "col-md-6",
    accept: "image/*",
    multiple: false,
    formHandler: fh,
    name: name ,
    label: name,
    setValue: value => fh.set(name, value),
    value: fh.get(name),
})

const CUServiceCategory = ({ RecordID, modalID }) => {

    const { formHandler, onSubmit } = useForm()

    const { onPost, loading: isLoadingPost } = usePost(AddServiceCategory)
    const { onUpdate, loading: isLoadingUpdate } = useUpdate(updateServiceCategory)

    const { result: serviceCatgoryData } = useGet({
        ...LoadListDefault,
        defaultValue: {},
        endPoint: GetserviceCatgoryById,
        params: [RecordID],
        allowFetch: !!RecordID,
    })


    const { t } = useTranslation()


    const handleSubmit = () => {
        onSubmit((data) => {
            const reqObject = ReqObject({
                ServiceTypeId: data?.serviceCatType?.value,
                ParentCategoryId: data?.serviceCatParentType?.value,
                NameEN: data?.serviceCatNameEn,
                Name: data?.serviceCatName,
                serviceCatImage: formHandler.get('serviceCatImage'),
                ServiceCategoryIcon: formHandler.get('ServiceCategoryIcon')
            })

            RecordID ? onUpdate(RecordID, reqObject, () => modalID.current.click()) : onPost(reqObject, () => modalID.current.click())
        })
    }

    return (
        <Popup name={`${modalName}_${RecordID}`} recordID={RecordID} modalID={modalID} onApply={handleSubmit} title={`${t(`${modalName}`)} ${RecordID ? `# ${RecordID}` : ""}`}>
            <MLInputField formHandler={formHandler} name="serviceCatName" defaultValue={serviceCatgoryData} />

            <DropDown isMulti={false} formHandler={formHandler} label="serviceCatType" endPoint={GetServiceTypeLookUp} defaultValue={serviceCatgoryData?.serviceTypeId} />
            <DropDown isRequired={false} isMulti={false} formHandler={formHandler} label="serviceCatParentType" endPoint={() => GetCatgories(SERVICES_TYPES.Medical)} defaultValue={serviceCatgoryData?.parentCategoryId} />
           
            <FileUpload {...commontFieldsProps('ServiceCategoryImgs', formHandler)} />
            <FileUpload {...commontFieldsProps('ServiceCategoryIcon', formHandler)} />


        </Popup >
    )
}

export default CUServiceCategory